import { FaFolder } from 'react-icons/fa';
import styled from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

export const SearchContainer = styled.div`
  padding-bottom: 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  overflow: auto;
`;

interface IFolderIconProps {
  $isSystemFolder?: boolean;
}
export const FolderIcon = styled(FaFolder)<IFolderIconProps>`
  height: 1.5rem;
  width: 1.5rem;
  color: ${({ $isSystemFolder = false }) =>
    $isSystemFolder ? colors.blue250 : colors.gray250};
`;
